import React, { useState } from 'react';
import { AiOutlinePlus } from "react-icons/ai";
import { AiOutlineMinus } from "react-icons/ai";


function Faqs2({question, answer}) {

    const [isAnswer, setisAnswer] = useState(false)

  return (
    <article className='faq' onClick={() => setisAnswer(prev => !prev)}>
        <div>
            <h4>{question}</h4>
            <button className='faq__icon'>
                {
                    isAnswer ? <AiOutlineMinus /> : <AiOutlinePlus />
                }
                
            </button>
        </div>

        {isAnswer && <p>{answer}</p>}
    </article>
  )
}

export default Faqs2